import AppDispatcher from '../dispatcher/AppDispatcher';
import InternetBankingConstants from '../constants/InternetBankingConstants';

const InternetBankingServerActionCreator = {
  raise(actionType, data) {
    AppDispatcher.handleServerAction({
      actionType,
      data,
    });
  },

  handleProductOfferSuccess(response) {
    AppDispatcher.handleServerAction({
      actionType: InternetBankingConstants.REQUEST_PRODUCT_OFFER_SUCCESS,
      data: response,
    });
  },

  handleCaseUpdateError(body) {
    AppDispatcher.handleServerAction({
      actionType: InternetBankingConstants.UPDATE_CASE_ERROR,
      data: {
        body,
      },
    });
  },
};

export default InternetBankingServerActionCreator;
